import React from 'react';
import './analysis.css';
import { useTheme } from '../../components/context/ThemeContext';
import ContactRequest from '../../components/contact_request/ContactRequest';
import DEMGeneration from './components/DEMGeneration';
import ChangeDetection from './components/ChangeDetection';
import VegetationAnalysis from './components/VegetationAnalysis';
import InfrastructureAnalysis from './components/InfrastructureAnalysis';
import HydrologicalModeling from './components/HydrologicalModeling';

const Analysis = () => {
    const { theme } = useTheme();
    
    return (
        <div className={`analysis-container ${theme}`}>
            <div className="analysis-header">
                <h1>LiDAR Analysis Solutions</h1>
                <p>Converting raw point cloud data into actionable insights for informed decision-making</p>
                <div className="top-cta">
                    <ContactRequest />
                </div>
            </div>
            
            <DEMGeneration />
            <ChangeDetection />
            <VegetationAnalysis />
            <InfrastructureAnalysis />
            <HydrologicalModeling />
            
            <div className="bottom-cta">
                <h2>Ready to Transform Your LiDAR Data into Actionable Intelligence?</h2>
                <p>Our team of geospatial analysts and data scientists can help you extract maximum value from your LiDAR datasets with customized analysis solutions tailored to your industry needs.</p>
                <ContactRequest />
            </div>
        </div>
    );
};

export default Analysis;